(function () {
    'use strict';
    var controllerId = 'logout';
    angular.module('app').controller(controllerId, ['$rootScope',logoutFn]);

    function logoutFn($rootScope) {
        var vm = this;
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 
    }
})();